import styled from 'styled-components';
import { grid, GridProps } from 'styled-system';

export const CalendarContainer = styled.div<GridProps>`
  display: grid;
  ${grid};
`;
